import {createSlice} from "@reduxjs/toolkit";
import moment from "moment/moment";

export const initialAiModuleRequestData = {
    page: 1,
    month: "",
    fileType: [],
    status: [],
    invoiceType: [],
    scoreFrom: "",
    scoreTo: "",
    fileName: "",
    general: "",
    // Sorting
    sortBy: "",
    sortType: "",
}

export const initialAiMrModuleRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    fileType: [],
    status: [],
    myDataType: [],
    scoreFrom: "",
    scoreTo: "",
    general: "",
    // Sorting
    sortBy: "",
    sortType: "",
}


const initialState = {
    aiSettings: {},
    aiModuleType: "files", // files || myDataClearance
    aiModuleRequestData: initialAiModuleRequestData,
    aiModuleData: {
        data: [],
        totalRows: 0,
        totalPages: 0,
        massRegisterApplicable: false,
        massReprocessApplicable: false,
        massDeclineApplicable: false,
        unClassifiedMonths: []
    },
    aiModuleSelectedRows: [],
    // myData Report
    aiMrModuleRequestData: initialAiMrModuleRequestData,
    aiMrModuleData: {
        data: [],
        totalRows: 0,
        totalPages: 0,

        massRegisterApplicable: false,
        massReprocessApplicable: false,
        massDeclineApplicable: false,
    },
    aiMrModuleSelectedRows: [],

    companiesAiUsageRequestData: {
        page: 1,
        firstLoad: true,
        date_from: moment().startOf("month").format("DD/MM/YYYY"),
        date_to: moment().endOf("month").format("DD/MM/YYYY"),
        companies: [],
        aiChannel: "all",
        geminiCostFrom: null,
        geminiCostTo: null,
        primerCostFrom: null,
        primerCostTo: null,
        creditConversion: 0.013,
    },
    companiesAiUsageResponseData: {
        totalPages: 0,
        data: [],
        creditConversion: 0.013,
    }
}

export const AISlice = createSlice({
    name: "ai-slice",
    initialState,
    reducers: {
        setAIModuleType: (state, {payload}) => {
            state.aiModuleType = payload;
        },
        setAISettings: (state, {payload}) => {
            state.aiSettings = payload;
        },
        setAIModuleRequestData: (state, {payload}) => {
            state.aiModuleRequestData = payload;
        },
        setAIModuleData: (state, {payload}) => {
            state.aiModuleData = payload;
        },
        setAIModuleSelectedRows: (state, {payload}) => {
            state.aiModuleSelectedRows = payload;
        },
        setAIMrModuleRequestData: (state, {payload}) => {
            state.aiMrModuleRequestData = payload;
        },
        setAIMrModuleData: (state, {payload}) => {
            state.aiMrModuleData = payload;
        },
        setAIMrModuleSelectedRows: (state, {payload}) => {
            state.aiMrModuleSelectedRows = payload;
        },
        setCompaniesAiUsageRequestData: (state, {payload}) => {
            state.companiesAiUsageRequestData = payload;
        },
        setCompaniesAiUsageResponseData: (state, {payload}) => {
            state.companiesAiUsageResponseData = payload;
        }
    }
})

export const {
    setAIModuleType,
    setAISettings,
    setAIModuleRequestData,
    setAIModuleData,
    setAIModuleSelectedRows,
    setAIMrModuleRequestData,
    setAIMrModuleSelectedRows,
    setAIMrModuleData,
    setCompaniesAiUsageRequestData,
    setCompaniesAiUsageResponseData,
} = AISlice.actions;
